import { render, staticRenderFns } from "./CampoDeItemDeVenda.vue?vue&type=template&id=6b0d4e69&"
import script from "./CampoDeItemDeVenda.vue?vue&type=script&lang=ts&"
export * from "./CampoDeItemDeVenda.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports